/* eslint-disable no-undef */
import { createDriver } from "@redux-requests/axios";
import { handleRequests } from "@redux-requests/core";
import axios from "axios";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { actionSanitizer, stateSanitizer } from "utils/helpers";
//reducers
import { Comment } from "features/comments/reducer/commentSlice";
import { Table } from "features/grid-table/reducer/TableSlice.js";
import WorkspaceReducer from "features/workspace/reducer/WorkspaceReducer";
import { enableMapSet } from "immer";
import AuthReducer from "../features/auth/reducer/AuthReducer";
import ActionReducer from "../features/cx-actions/reducer/ActionReducer";
import FolderReducer from "../features/folders/reducer/FoldersReducer";
import CxProgramReducer from "../features/forms/cx-programs/reducer/CxProgramReducer";
import StrategyReducer from "../features/forms/cx-strategy/reducer/StrategyReducer";
import PersonaReducer from "../features/forms/personas/reducer/PersonaReducer";
import InsightReducer from "../features/insights/reducer/InsightReducer";
import CJMReducer from "../features/journey-map/reducer/CJMReducer";
import LibrariesReducer from "../features/library/reducer/LibrariesReducer";
import OpportunityReducer from "../features/opportunity/reducer/OpportunityReducer";
import ProjectReducer from "../features/projects/reducer/ProjectReducer";
import settingsReducer from "../features/settings/reducer/SettingsReducer";
import SolutionsReducer from "../features/solutions/reducer/SolutionsReducer";
import { cancelableRequestsMiddleware, customMiddleWare, checkEmptyListMiddleware } from "./middleware";
import { Page } from "./pageReducer";
import { persistStore, persistReducer } from "redux-persist";
import { createBrowserHistory } from "history";
import { urlValidationAndRedirect, getBasename } from "./helpers";
import createIndexedDBStorage from "redux-persist-indexeddb-storage";
import journeyTrendReducer from "features/analytics/reducer/JourneyTrend/journeyTrendReducer";
import vocAnalysisReducer from "features/analytics/reducer/VoCAnalysis/vocAnalysisReducer";
import roiAnalysisReducer from "features/analytics/reducer/ROIAnalysis/roiAnalysisReducer";
const uiReducers = combineReducers({
	page: Page.reducer,
	table: Table.reducer,
	comment: Comment.reducer,
});

enableMapSet();

function ConfigureStore(history, initialState) {
	const { requestsReducer, requestsMiddleware } = handleRequests({
		driver: createDriver(axios),
		takeLatest: false,
	});

	const analyticsReducer = combineReducers({
		journeyTrend: journeyTrendReducer,
		vocAnalysis: vocAnalysisReducer,
		roiAnalysis: roiAnalysisReducer,
	});

	const rootReducer = combineReducers({
		router: connectRouter(history),
		auth: AuthReducer,
		settings: settingsReducer,
		libraries: LibrariesReducer,
		folders: FolderReducer,
		maps: CJMReducer,
		insights: InsightReducer,
		personas: PersonaReducer,
		actions: ActionReducer,
		opportunity: OpportunityReducer,
		solutions: SolutionsReducer,
		projects: ProjectReducer,
		strategies: StrategyReducer,
		cxProgram: CxProgramReducer,
		ui: uiReducers,
		requests: requestsReducer,
		analytics: analyticsReducer,
		workspaces: WorkspaceReducer,
	});

	const persistConfig = {
		key: "root",
		storage: createIndexedDBStorage("cemantica-local-db"), // Name your IndexedDB database
		whitelist: ["auth", "settings", "libraries"], // Choose reducers to persist
	};

	const persistedReducer = persistReducer(persistConfig, rootReducer);
	const enhancers = applyMiddleware(routerMiddleware(history), cancelableRequestsMiddleware, checkEmptyListMiddleware, customMiddleWare, ...requestsMiddleware, thunk);
	let composeEnhancers = compose(enhancers);
	if (process.env.NODE_ENV === "development") {
		composeEnhancers = composeWithDevTools({
			trace: true, // if you want to enable tracing
			traceLimit: 15, // limit the trace steps
			serialize: {
				options: true,
			},
			actionSanitizer, // Include your actionSanitizer
			stateSanitizer, //
		})(enhancers);
	}
	const store = createStore(persistedReducer, initialState, composeEnhancers);
	const persistor = persistStore(store); // Create the persistor instance

	return { store, persistor };
}
const base = getBasename(window.location.pathname);
const history = createBrowserHistory({ basename: base });
urlValidationAndRedirect(window.location.pathname, history, base);
const { store, persistor } = ConfigureStore(history, window.initialReduxState);

export { store, persistor, history, base };
